import {CommonDecisionTreeNodeType, MacroDecisionTreeNodeType} from '@frontapp/workflows/decision_trees';

import {MacroFlowBuilderNodeData} from '../../../../libs/shared/core/src/helpers/types/macroFlowBuilderTypes';
import {LayoutOptions} from '../../../../libs/shared/ui/src/components/decisionTrees/decisionTreeBuilder/decisionTreeLayout';
import {nodeSpacingFromDirection} from '../../../../libs/shared/ui/src/components/decisionTrees/decisionTreeBuilder/helpers';
import {flowBuilderDirection} from '../../../../libs/shared/ui/src/components/decisionTrees/flowBuilder/constants';

/*
 * Constants.
 */

/**
 * Specifies the direction of the flow builder in addition to the custom spacing logic that is needed
 * for certain node data types.
 */

export const macroFlowBuilderLayoutOptions: LayoutOptions<MacroFlowBuilderNodeData> = {
  direction: flowBuilderDirection,
  computeNodeSize: (data: MacroFlowBuilderNodeData): [number, number] => {
    const nodeSpacing = nodeSpacingFromDirection(flowBuilderDirection);

    // We halve the spacing from the start node for overall visual consistency with other nodes.
    if (data.type === MacroDecisionTreeNodeType.START) {
      return [nodeSpacing[0], nodeSpacing[1] / 3];
    }

    if (data.type === CommonDecisionTreeNodeType.ACTION) {
      const spacingMultiplier = 1 + data.actions.length * 0.1;
      return [nodeSpacing[0] * spacingMultiplier, nodeSpacing[1]];
    }

    if (data.type === CommonDecisionTreeNodeType.BRANCH_BY_CONDITION) {
      const spacingMultiplier = 1 + data.options.length * 0.2;
      return [nodeSpacing[0] * spacingMultiplier, nodeSpacing[1]];
    }

    if (data.type === MacroDecisionTreeNodeType.COLLECT_INPUT) {
      const spacingMultiplier = 1 + data.inputs.length * 0.2;
      return [nodeSpacing[0] * spacingMultiplier, nodeSpacing[1]];
    }

    return nodeSpacing;
  },
};

export const maxMacroFlowNodesCount = 50;

export const branchByConditionMinOptions = 1;
export const branchByConditionMaxOptions = 8;
